import { createAction, props } from '@ngrx/store';

export const navigationMemoryActions = {
  keep: createAction(
    '[NavigationMemory] Keep',
    props<{
      key: string;
      payload: unknown;
      urlSource: string;
      urlTarget: string;
    }>(),
  ),
  updateHop: createAction(
    '[NavigationMemory] Update hop',
    props<{ url: string }>(),
  ),
  reset: createAction('[NavigationMemory] Reset'),
};
export type NavigationMemoryAction = typeof navigationMemoryActions;
